// バックエンドの場所。
//   REACT_APP_API_BASE を指定  … そのURLを使う（フロントとバックエンドが別ドメインのとき）
//   未指定 かつ 本番           … 同一オリジン。nginx などが /api を中継する構成
//   未指定 かつ 開発           … localhost / 社内LAN IP の 5002 を直接叩く
//
// Cloudflare Pages のように静的ホスティングへ置く場合はフロントと
// バックエンドが別オリジンになるため、ビルド時に REACT_APP_API_BASE が必須。
export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === 'production'
    ? ''
    : `http://${window.location.hostname}:5002`);

export async function startConversation(keyword) {
  const response = await fetch(`${API_BASE}/api/conversation/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ keyword }),
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || '会話の生成に失敗しました');
  }
  return response.json();
}

export async function continueConversation(keyword, history) {
  const response = await fetch(`${API_BASE}/api/conversation/continue`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ keyword, history }),
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || '続きの生成に失敗しました');
  }
  return response.json();
}

export async function fetchConfig() {
  const response = await fetch(`${API_BASE}/api/config`);
  if (!response.ok) {
    throw new Error('設定の読み込みに失敗しました');
  }
  return response.json();
}

export async function saveConfig(config) {
  const response = await fetch(`${API_BASE}/api/config`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(config),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || '設定の保存に失敗しました');
  }
  return response.json();
}

export async function fetchVoices() {
  const response = await fetch(`${API_BASE}/api/tts/voices`);
  if (!response.ok) {
    throw new Error('声一覧の取得に失敗しました');
  }
  return response.json();
}

export async function previewVoice(speaker, voice, text) {
  const response = await fetch(`${API_BASE}/api/tts/preview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ speaker, voice, text }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || '試聴の生成に失敗しました');
  }
  const blob = await response.blob();
  return URL.createObjectURL(blob);
}

export async function previewConversation(keyword, config) {
  const response = await fetch(`${API_BASE}/api/conversation/preview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ keyword, config }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'プレビューの生成に失敗しました');
  }
  return response.json();
}

export async function fetchTTS(speaker, text) {
  const response = await fetch(`${API_BASE}/api/tts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ speaker, text }),
  });
  if (!response.ok) {
    throw new Error('音声の生成に失敗しました');
  }
  const blob = await response.blob();
  return URL.createObjectURL(blob);
}
